import React from 'react';
import { Network, Shield, Wifi, Activity, AlertTriangle } from 'lucide-react';
import { FeaturePreview } from './FeaturePreview';

/**
 * Feature preview component for IP Addresses feature
 * Displays information about the IP Addresses feature and its benefits
 */
export const IpAddressesFeaturePreview: React.FC = () => {
  return (
    <FeaturePreview
      title="IP Address Asset Management"
      description="Discover, monitor, and manage all your IP address assets with comprehensive security insights and risk assessment."
      icon={<Network className="h-8 w-8 text-blue-600" />}
      featureName="ip-addresses"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
        {/* Feature Card 1 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <Shield className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">IP Security Monitoring</h3>
          </div>
          <p className="text-gray-400">
            Monitor all your IP addresses for security vulnerabilities, open ports, and potential threats in real-time.
          </p>
        </div>

        {/* Feature Card 2 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <Wifi className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Network Mapping</h3>
          </div>
          <p className="text-gray-400">
            Visualize your network infrastructure with comprehensive IP address mapping and relationship analysis.
          </p>
        </div>

        {/* Feature Card 3 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <Activity className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Uptime Monitoring</h3>
          </div>
          <p className="text-gray-400">
            Track IP address availability and performance with detailed uptime metrics and historical data.
          </p>
        </div>

        {/* Feature Card 4 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <AlertTriangle className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Threat Detection</h3>
          </div>
          <p className="text-gray-400">
            Identify and mitigate potential threats targeting your IP addresses with advanced threat intelligence.
          </p>
        </div>
      </div>
    </FeaturePreview>
  );
};
